import { render } from "./PieChartPainter.vue?vue&type=template&id=6752f4e2"
import script from "./PieChartPainter.vue?vue&type=script&lang=js"
export * from "./PieChartPainter.vue?vue&type=script&lang=js"

import "./PieChartPainter.vue?vue&type=style&index=0&id=6752f4e2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__